import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=5492983522024"
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/img/wsp.png" alt="WhatsApp" />
    </a>
  );
};

export default WhatsAppButton;
